<template lang="pug">
  div.color-scroller(
    ref="observable"
    :class="{ 'visible' : contentVisible }"
  )
    .color-scroller__background(
      :style="gradientStyle"
    )
    slot
</template>

<script>
  import IOLazyLoader from 'scripts/mixins/IOLazyLoader.js';

  export default {
    name: 'ColorScroller',
    mixins: [ IOLazyLoader ],
    props: {
      colorOne: String,
      colorTwo: String,
    },
    data() {
      return {
        offset: 0,
        contentVisible: false,
      };
    },
    mounted() {
      document.addEventListener('scroll', this.setGradientOffset);
    },
    computed: {
      gradientStyle() {
        return {
          left: `-${this.offset}%`,
          background: `linear-gradient(to right, ${this.colorOne}, ${this.colorTwo}, ${this.colorOne})`,
        };
      },
    },
    methods: {
      /**
       * Check if the gradient is in the viewport, and if so then update
       * the gradient
       */
      setGradientOffset() {
        const rect = this.$refs.observable.getBoundingClientRect();
        const height = parseInt(window.innerHeight, 10);
        const percentToTop = (rect.top / height) * 100;
        const percentConverted = Math.abs(percentToTop - 100);
        this.offset = Math.round(Math.max(0, Math.min(200, percentConverted)));
        if (percentToTop < 60) {
          this.contentVisible = true;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .color-scroller {
    position: relative;
    width: 100%;
    overflow-x: hidden;

    *:not(.button) {
      opacity: 0;
      transition: opacity 2s;
    }

    &.visible * {
      opacity: 1;
    }

    .color-scroller__background {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      width: 300%;
      z-index: -1;
      opacity: 1;
    }
  }
</style>
